import { useEffect } from 'react';
import Grid from '@mui/material/GridLegacy'
import {
  Box,
  Typography
} from '@mui/material';
import { AlertTriangle, ArrowLeft, CheckCircle2, Clock, MessageCircle, Rocket, Stethoscope, TrendingUp, Wrench, Zap } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function ContactPage() {
  // const [formData, setFormData] = useState({
  //   company: '',
  //   name: '',
  //   phoneNumber: '',
  //   emailAddress: '',
  // });

  // Load Calendly widget script
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
    
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // const handleChange = (
  //   e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  // ) => {
  //   setFormData({
  //     ...formData,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // console.log('Form data:', formData);
    
    // Store form data in localStorage so it can be accessed if needed
    // localStorage.setItem('contactFormData', JSON.stringify(formData));
    
    // Handle form submission (e.g., send to backend)
    alert('Thank you! We will contact you soon.');
  };

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Grid container spacing={0} sx={{ minHeight: '100vh' }}>
        {/* Left Side - Form */}
        <Grid item xs={12} md={7} sx={{ bgcolor: 'background.paper' }}>
          <Box sx={{ width: '100%', maxWidth: '700px', py: { xs: 6, md: 10 }, px: { xs: 3, md: 6 }, mx: 'auto' }}>
            {/* Form Section */}
            <Box sx={{ mb: 6 }}>

              <Box component="form" onSubmit={handleSubmit}>
                {/* Calendly Time Selection */}
                <Box sx={{ mb: 3 }}>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      mb: 1,
                      color: 'text.primary',
                    }}
                  >
                    * Select your preferred time
                  </Typography>
                  <Box
                    className="calendly-inline-widget"
                    data-url="https://calendly.com/dineshanbumani/prod-release-service-discovery-call"
                    sx={{
                      minWidth: '320px',
                      height: '600px',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      border: 1,
                      borderColor: 'divider',
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* Right Side - Info Section */}
        <Grid item xs={12} md={5} sx={{ bgcolor: 'background.default' }}>
          <Box 
            sx={{ 
              py: { xs: 6, md: 10 }, 
              px: { xs: 3, md: 6 },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            {/* Home Link */}
            <Box 
              component={Link}
              to="/"
              sx={{ 
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                mb: 4,
                color: 'text.primary',
                textDecoration: 'none',
                '&:hover': {
                  color: '#1EB980',
                },
              }}
            >
              <Typography>Home</Typography>
              <ArrowLeft size={18} />
            </Box>

            {/* Heading */}
            <Typography 
              variant="h4"
              sx={{ 
                mb: 4,
                fontWeight: 700,
                color: 'black',
              }}
            >
              Talk to Our Expert
            </Typography>

            {/* Four Pill Cards in 2x2 Grid */}
            <Box sx={{ mb: 4, display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1.5, width: '100%' }}>
              {/* Discussions Pill */}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 0.75,
                  bgcolor: 'rgba(30, 185, 128, 0.1)',
                  border: '2px solid rgba(30, 185, 128, 0.3)',
                  borderRadius: '16px',
                  px: 1.5,
                  py: 1.5,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    bgcolor: 'rgba(30, 185, 128, 0.15)',
                    borderColor: '#1EB980',
                    transform: 'translateY(-3px)',
                  },
                }}
              >
                <Box
                  sx={{
                    width: 28,
                    height: 28,
                    borderRadius: '50%',
                    bgcolor: '#1EB980',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <MessageCircle size={14} color="white" />
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    color: 'text.primary',
                    fontSize: '0.7rem',
                    textAlign: 'center',
                    lineHeight: 1.2,
                  }}
                >
                  No charge discussions
                </Typography>
              </Box>

              {/* Diagnosis Pill */}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 0.75,
                  bgcolor: 'rgba(85, 255, 225, 0.1)',
                  border: '2px solid rgba(85, 255, 225, 0.3)',
                  borderRadius: '16px',
                  px: 1.5,
                  py: 1.5,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    bgcolor: 'rgba(85, 255, 225, 0.15)',
                    borderColor: '#55FFE1',
                    transform: 'translateY(-3px)',
                  },
                }}
              >
                <Box
                  sx={{
                    width: 28,
                    height: 28,
                    borderRadius: '50%',
                    bgcolor: '#55FFE1',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <Stethoscope size={14} color="#0a4a3a" />
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    color: 'text.primary',
                    fontSize: '0.7rem',
                    textAlign: 'center',
                    lineHeight: 1.2,
                  }}
                >
                  No charge diagnosis
                </Typography>
              </Box>

              {/* Outcomes Pill */}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 0.75,
                  bgcolor: 'rgba(139, 92, 246, 0.1)',
                  border: '2px solid rgba(139, 92, 246, 0.3)',
                  borderRadius: '16px',
                  px: 1.5,
                  py: 1.5,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    bgcolor: 'rgba(139, 92, 246, 0.15)',
                    borderColor: '#8B5CF6',
                    transform: 'translateY(-3px)',
                  },
                }}
              >
                <Box
                  sx={{
                    width: 28,
                    height: 28,
                    borderRadius: '50%',
                    bgcolor: '#8B5CF6',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <Rocket size={14} color="white" />
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    color: 'text.primary',
                    fontSize: '0.7rem',
                    textAlign: 'center',
                    lineHeight: 1.2,
                  }}
                >
                  Charge only outcomes
                </Typography>
              </Box>

              {/* Fast Response Pill */}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 0.75,
                  bgcolor: 'rgba(251, 146, 60, 0.1)',
                  border: '2px solid rgba(251, 146, 60, 0.3)',
                  borderRadius: '16px',
                  px: 1.5,
                  py: 1.5,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    bgcolor: 'rgba(251, 146, 60, 0.15)',
                    borderColor: '#FB923C',
                    transform: 'translateY(-3px)',
                  },
                }}
              >
                <Box
                  sx={{
                    width: 28,
                    height: 28,
                    borderRadius: '50%',
                    bgcolor: '#FB923C',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <Clock size={14} color="white" />
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    color: 'text.primary',
                    fontSize: '0.7rem',
                    textAlign: 'center',
                    lineHeight: 1.2,
                  }}
                >
                  24hr response
                </Typography>
              </Box>
            </Box>

            {/* Free Review Card */}
            <Box
              sx={{
                bgcolor: 'background.paper',
                borderRadius: '12px',
                border: '1px solid',
                borderColor: 'divider',
                p: 3,
                mb: 4,
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                textAlign: 'left',
                width: '100%',          // takes full width of column
                maxWidth: '50vw',      // increase as needed (default is ~350)
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  mb: 3,
                  color: 'text.secondary',
                  lineHeight: 1.6,
                  fontSize: '0.875rem',
                }}
              >
                Get a free expert review of your hiring, delivery, or architecture challenges.
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  mb: 2,
                  fontWeight: 600,
                  color: 'text.primary',
                  fontSize: '0.875rem',
                }}
              >
                We&apos;ll share:
              </Typography>

              {/* What we'll share - with icons */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <AlertTriangle size={16} color="#F59E0B" strokeWidth={2.5} />
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'text.secondary',
                      fontSize: '0.875rem',
                    }}
                  >
                    What&apos;s broken
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Wrench size={16} color="#3B82F6" strokeWidth={2.5} />
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'text.secondary',
                      fontSize: '0.875rem',
                    }}
                  >
                    What to fix
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <TrendingUp size={16} color="#1EB980" strokeWidth={2.5} />
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'text.secondary',
                      fontSize: '0.875rem',
                    }}
                  >
                    How to scale
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Zap size={16} color="#8B5CF6" strokeWidth={2.5} />
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'text.secondary',
                      fontSize: '0.875rem',
                    }}
                  >
                    How fast we can get you to production-ready
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Bottom text with icon */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                bgcolor: 'rgba(30, 185, 128, 0.05)',
                borderRadius: '8px',
                p: 2,
                mb: 4,
                border: '1px dashed rgba(30, 185, 128, 0.3)',
              }}
            >
              <CheckCircle2 size={20} color="#1EB980" strokeWidth={2.5} />
              <Typography
                variant="body2"
                sx={{
                  color: 'text.secondary',
                  lineHeight: 1.5,
                  fontStyle: 'italic',
                  fontSize: '0.875rem',
                }}
              >
                All before you ever spend a rupee or dollar.
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}